import React,{Component} from "react";

// reactstrap components
import {
  Col,
  Row,
  Progress,
  Button
} from "reactstrap";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import Sound from 'react-sound';
import getBlobDuration from 'get-blob-duration';
import {base,s3base} from "api.js";
import NoMicrophone from "views/NoMicrophone.jsx";
import MicRecorder from 'mic-recorder-to-mp3';
import SpeechToText from "components/Question/Speaking/New/SpeechToText";

import "components/custom.css";
import { getDuration } from "util/blobUtils";
import { getFile } from "util/blobUtils";
import { getBlobURL } from "util/blobUtils";

let Mp3Recorder = new MicRecorder({ bitRate: 128 });

class DescribeImage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isRecording: false,
      blobURL: '',
      isBlocked: false,
      question:"",
      secondCount:25,
      recordCount:0,
      recordId:1,
      intervalId:0,
      duration:0,
      questionId:"",
      reset:false,
      trans:'',
      correctFlag:true,
      soundStatus:false,
      file:'',
      imageLoaded:true,
      saveTranscript: false
    };
      this.transcriptTimeout = null;
  }

 componentDidMount() {
  if (!this.props.answer) {
    const intervalId = setInterval(this.timer, 1000);
    this.setState({ intervalId });
  }

  navigator.getUserMedia({ audio: true },
    () => this.setState({ isBlocked: false }),
    () => this.setState({ isBlocked: true })
  );
}


  componentDidUpdate(prevProps, prevState) {
  if (
    this.props.data &&
    this.props.data.media_link !== prevProps.data?.media_link
  ) {
    this.setState({ imageLoaded: false });

    const img = new Image();
    img.src = s3base + this.props.data.media_link;

    img.onload = () => {
      console.log("Image loaded successfully");
      this.setState({ imageLoaded: true });

      const intervalId = setInterval(this.timer, 1000);
      this.setState({ intervalId, reset: false });
    };

    img.onerror = () => {
      console.error("❌ Image failed to load:", img.src);
    };
  }

   if (
    prevState.isRecording === true && 
    this.state.isRecording === false && 
    this.state.saveTranscript === true &&
    prevState.saveTranscript === false
  ) {
    console.log("No response wait for 3 second and move to next question")
    // Clear any existing timeout
    if (this.transcriptTimeout) {
      clearTimeout(this.transcriptTimeout);
    }
    
    // If transcript not received in 3 seconds, proceed anyway
    this.transcriptTimeout = setTimeout(() => {
      if (this.state.saveTranscript === true) {
        console.warn('⚠️ Transcript not received in time, proceeding without it');
        
        const data_to_send = {
          data: this.state.file,
          audio_text: this.state.trans || '', // Use existing or empty
          duration: this.state.duration
        };
        
        if (this.props.testMode) {
          console.log("Calling from the componentDidUpdate");
          this.props.nextQuestion(data_to_send);
        } else {
          this.props.submit(data_to_send, true);
          this.props.showResult();
        }
        
        // Reset state to prevent duplicate calls
        this.setState({ saveTranscript: false });
      }
    }, 3000);
  }
}


  revokeBlobURL = () => {
    const { blobURL } = this.state;
    if (blobURL) {
      try {
        // Only revoke if URL exists and is a proper blob URL
        if (blobURL.startsWith("blob:")) {
          URL.revokeObjectURL(blobURL);
          console.log("🧹 Revoked blob URL instantly:", blobURL);
        }
      } catch (err) {
        console.error("⚠️ Failed to revoke blob URL:", err);
      } finally {
        // Clear from state to prevent reuse
        this.setState({ blobURL: '' });
      }
    }
  };

  static getDerivedStateFromProps(props, state) {
  	if (props.data) {
  		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
  			clearInterval(state.intervalId);
  			clearInterval(state.recordId);
  			
  			return {recordCount:0,isRecording:false,secondCount:25,questionId: props.data.id,blobURL:'',reset:true,imageLoaded:false,trans:'',duration:0};
  		}else{
  			if (!state.questionId) {
  				return {questionId: props.data.id,imageLoaded:false};
  			}
  		}	
  		} 
  }


  start = () => {
    this.setState({ soundStatus: true});
  };

  handleSongFinishedPlaying = () =>{
    if (this.state.isBlocked) {
      console.log('Permission Denied');
    } else {
      SpeechRecognition.startListening({ continuous: true, language: 'en-GB' })
      Mp3Recorder = new MicRecorder({ bitRate: 128 });
      Mp3Recorder
        .start()
        .then(() => {
          this.setState({ isRecording: true,blobURL:'',soundStatus:false});
        }).catch((e) => console.error(e));
    }
  }

  setTrans = (a)=>{
    if (this.state.trans != a) {
      this.setState({trans:a})  
    }
    
  }

  stop = () => {
    if (!this.state.isBlocked && this.state.isRecording) {
      Mp3Recorder
        .stop()
        .getMp3()
        .then(async ([buffer, blob]) => {
          this.revokeBlobURL();
           if(blob && blob.size > 0){
          const duration = await getDuration(blob);
          const file = await getFile(blob, buffer,'noname2.mp3');
          const blobURL = await getBlobURL(blob, file);
           this.setState({
            blobURL,
            isRecording: false,
            recordCount:100,
            file,
            saveTranscript: true,
            duration
          });
          SpeechRecognition.stopListening();
           }else{
            this.setState({
            isRecording: false,
            recordCount:100,
            file:null,
            saveTranscript: true,
            duration:0
          });
           }
         
        }).catch((e) => console.log(e));
    }
  };

  stopTest = async () => { 
    if (!this.state.isBlocked && this.state.isRecording) {
      Mp3Recorder
        .stop()
        .getMp3()
        .then( async ([buffer, blob]) => {
          this.revokeBlobURL();
          // const blobURL = URL.createObjectURL(blob);
          // let duration = await getBlobDuration(blobURL);
          // //this.setState({ isRecording: false,recordCount:100 });
          // let file = new File([blob], 'noname1.mp3', { type: blob.type });
          if(blob && blob.size > 0){
          const duration = await getDuration(blob);
          const file = await getFile(blob, buffer,'noname2.mp3');
          const blobURL = await getBlobURL(blob, file);
          console.log('file:', file)
          SpeechRecognition.stopListening();

          this.setState({
            blobURL,
            isRecording: false,
            recordCount:100,
            saveTranscript: true,
            file,
            duration
          });
          }else{
             this.setState({
            blobURL:'',
            isRecording: false,
            recordCount:100,
            saveTranscript: true,
            file:null,
            duration:0
          });
          }
          // below line was moved to setTranscript()
          // this.props.nextQuestion({'data': file,'audio_text':this.state.trans, duration:duration });
        }).catch((e) => console.log(e));
    } 
    else if (!this.state.isRecording && this.state.secondCount > 0) {
    console.log('⚠️ User skipped without recording');
    
    // Clear the preparation timer
    clearInterval(this.state.intervalId);
    
    // Submit with empty data immediately
    const data_to_send = {
      data: null,
      audio_text: '',
      duration: 0
    };
    
    if (this.props.testMode) {
      this.props.nextQuestion(data_to_send);
    } else {
      this.props.submit(data_to_send, true);
      this.props.showResult();
    }
  }
    // else {
    //   this.props.nextQuestion({
    //     data: this.state.file,
    //     audio_text: this.state.trans,
    //     duration: this.state.duration
    //   });      
    // }
  };

  updateCorrect = () =>{
     this.props.submit({'data':'', 'audio_text':'','duration':this.state.duration});
     this.setState({correctFlag:false})
  }

  skip = () => {
    clearInterval(this.state.intervalId);
    this.start();
    var recordId = setInterval(this.timerRecord, 1000);
    this.setState({recordId: recordId,secondCount:0});
  };

	timer = () => {
		if (this.state.secondCount === 1) {
			clearInterval(this.state.intervalId);
			this.start();
			var recordId = setInterval(this.timerRecord, 1000);
			this.setState({recordId: recordId});
		}
		this.setState({ secondCount: this.state.secondCount -1 });
	}



	timerRecord = () => {
		if (this.state.recordCount === 40) {
			clearInterval(this.state.recordId);
			this.stop();
		}
		this.setState({ recordCount: this.state.recordCount + 1 });	
	}

	componentWillUnmount = () => {
		clearInterval(this.state.intervalId);
     if (this.transcriptTimeout) {
    clearTimeout(this.transcriptTimeout);
  }
     this.revokeBlobURL();
	}

  handleImageLoaded =() =>{
    this.setState({ imageLoaded: true });
  }

  setSaveTranscript = (status) => {
    this.setState({ saveTranscript: status });
  }

  setTranscript = (transcript) => {
    this.setState({
      trans: transcript,
      saveTranscript: false
    }, () => {
      console.log('this.state.trans::', this.state.trans)
      // this code was in stop() earlier.
      // after replace <Dictaphone /> with <SpeechToText />,  this code placed here.
      // to get transcript effectively.
      const data_to_send = {
        data: this.state.file,
        audio_text: this.state.trans,
        duration: this.state.duration
      };
      
      if (this.props.testMode) {
          console.log("Calling from the SetTranscript and the final one");
        this.props.nextQuestion(data_to_send);
      } else {
        this.props.submit(data_to_send, true);
        this.props.showResult();
      }
    });
  }
  
  render() {
  	let question ="";
    // if (!this.state.imageLoaded) {
    //   const img = new Image();
    //   img.src = s3base + this.props.data.media_link;
    //   if (img.complete) {
    //     var intervalId = setInterval(this.timer, 1000);
    //     this.setState({intervalId: intervalId,reset:false,imageLoaded:true});
          
    //   }
    // }
  	if (this.props.restart) {
      this.props.restartQue();
    }
    if (this.props.stopRecording) {
      this.stopTest();      
    }
    if (this.props.data) {
  		question = this.props.data.question;
      if (this.state.correctFlag) {
        this.updateCorrect();
      }
  	}
  	if (this.state.reset) {
  		/*var intervalId = setInterval(this.timer, 1000);
		this.setState({intervalId: intervalId,reset:false});*/
  	}
    if (this.state.isBlocked) {
      return (<NoMicrophone />);
    }
    
    return (
      <>
        {/*<Dictaphone setTrans={this.setTrans} status={this.state.reset || this.state.isRecording} />*/}
        
        <SpeechToText
          saveTranscript={this.state.saveTranscript}
          setTranscript={this.setTranscript}
        />

        <Col xs={12}>
        	<h4 className="infoText"></h4>
        </Col>
        <Col xs={12}>
          <Row>
            <Col lg={6}>
              {/* {!this.state.imageLoaded && <div style={{margin:'145px'}}>Loading...</div>}
              {this.state.imageLoaded && this.props.data &&  */}
              <img alt="media-link"
               width="500"
                onLoad={this.handleImageLoaded}
                onError={() => console.error("❌ Image failed to load:", s3base + this.props.data.media_link)}
                // src={`data:image/png;base64, ${this.props.data.media_link}`} />
                src={s3base + this.props.data.media_link} /> 
                {/* //  } */}
              
            </Col>
          	<div className="col-lg-6 p-0 text-center">
        		  {!this.props.resultMode && 
                <div className="audio-box">
                  <h4>Recorded Answer</h4>
                  <p><strong>Current status:</strong></p>
                  {/* <p>
                    {this.state.blobURL === '' && this.state.isRecording ? "Recording started" : `Recording starts in ${this.state.secondCount} seconds`}
                  </p> */}
                                     <p>
  {this.state.isRecording 
    ? "Recording started" 
    : this.state.blobURL 
      ? "Recording Finished" 
      : `Recording starts in ${this.state.secondCount} seconds`
  }
</p>
                  {!this.props.testMode && this.state.blobURL === '' && !this.state.isRecording && 
                    <div className='stop-btn'>
                      <Button color="success" onClick={this.skip} size="sm">Skip</Button>
                    </div>
                  }
                  <hr></hr>
                  {/*this.state.isRecording && "Recording Time : "+this.state.recordCount*/}
                  {!this.props.testMode && this.state.isRecording && 
                    <div className='stop-btn'>
                      <Button color="success" onClick={this.stop} size="sm">Stop</Button>
                    </div>
                  }
                  <hr></hr>
                  <Progress color="info" value={(this.state.recordCount*2.5)} />
                  <div className="audo-line"><span className="progress-bar-fill-Read intro"></span></div>
                </div>
              }
    		    </div>
          </Row>
          
          <Col xs={12}>
            {this.state.blobURL && !this.props.testMode && 
              <audio src={this.state.blobURL} controls="controls" />
            }
          </Col>
        </Col> 
        
        <Col xs={12}>
          <h5>{question}</h5>
        </Col>

        {!this.props.resultMode && this.state.soundStatus && 
          <Sound url={`${s3base}/ptedata/ptemedia/beep.mp3`} playStatus={Sound.status.PLAYING} onFinishedPlaying={this.handleSongFinishedPlaying} />
        }
      </>
    );
  }
}
export default DescribeImage;

